import React, { useContext } from "react";
import { withRouter } from "react-router-dom";
import { Text, ThemeContext } from "components/common";
import { colors, aux, darkThemeName } from "theme";
import { MORE } from "routes/pageConfig";
import { hasPagePermission } from "routes/utils";
import { parseInfo } from "./navHelper";
import { NAV_BAR_ITEMS, NUM_MOBILE_NAV_ITEMS } from "./consts";

const iconSize = 24;

const NavbarMobile = ({ history: { push }, location: { pathname } }) => {
  // iterate through items
  // get first valid four to appear in main nav
  // rest go into more
  const { theme } = useContext(ThemeContext);
  const mainOptions = [];
  const moreOptions = [];
  const moreItems = [];
  NAV_BAR_ITEMS.forEach((item) => {
    const hasPerms = hasPagePermission(item);
    if (!hasPerms || item.navBarSettings?.mobileNav?.hide) {
      return;
    }
    if (mainOptions.length < NUM_MOBILE_NAV_ITEMS) {
      mainOptions.push(item);
    } else if (item.key === MORE.key) {
      mainOptions.push(item);
    } else {
      moreItems.push(item.key);
      moreOptions.push(item);
    }
  });

  if (mainOptions[mainOptions.length - 1]?.key === MORE.key) {
    mainOptions[mainOptions.length - 1].moreItems = moreItems;
  }

  return (
    <div
      className={ `flex w-full fixed bottom-0 b-m-nav ${theme === darkThemeName ? "bg-black" : "bg-white"}` }
      style={{ height: aux.mobile.navbarHeight, maxWidth: "100%", zIndex: 70 }}
    >
      {mainOptions.map((item, index) => {
        const {
          key,
          Icon,
          iconName,
          title,
          path,
          moreItems: subItems,
          navBarSettings,
        } = item;
        const { color } = parseInfo(
          key,
          pathname,
          theme === darkThemeName ? colors.white : colors["black-primary"],
          subItems,
        );
        return (
          <div
            key={key}
            role="presentation"
            className="flex flex-col justify-center items-center"
            style={{
              flexGrow: 1,
              flexBasis: 0,
              maxWidth: aux.mobile.navbarHeight,
            }}
            onClick={() => {
              push(path);
            }}
          >
            {Icon && (
              <Icon
                color={color}
                style={{ height: iconSize, width: iconSize }}
              />
            )}
            {iconName && (
              <i
                style={{ width: iconSize, color, fontSize: iconSize }}
                className={`float-left fas ${iconName} text-center`}
              />
            )}
            <Text className="pt-1 text-xs capitalize font-medium" color={color}>
              {navBarSettings?.mobileNav?.title || title || key}
            </Text>
          </div>
        );
      })}
    </div>
  );
};

export default withRouter(NavbarMobile);
